import { Box } from "@twilio-paste/core/box";
import { Text } from "@twilio-paste/core/text";
import { Button } from "@twilio-paste/core/button";
import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";
import { Toast, ToastContainer, useToaster } from "@twilio-paste/toast";

import { containerStyles, titleStyles } from "./styles/Header.styles";
import { AppState } from "../store/definitions";
import contactBackend from "../utils/contactBackend";
import { ACTION_UPDATE_CONVERSATION_STATE } from "../store/actions/actionTypes";

export const Header = ({ customTitle, showExit }: { customTitle?: string; showExit?: boolean }) => {
    const dispatch = useDispatch();
    const { conversationSid } = useSelector((state: AppState) => state.session);
    const [isClosing, setIsClosing] = useState(false);
    const toaster = useToaster();

    const handleExit = async () => {
        if (isClosing) {
            return;
        }
        setIsClosing(true);
        try {
            if (conversationSid) {
                try {
                    await contactBackend<{ state: string }>("/conversation", { conversationSid });
                } catch (error) {
                    console.warn("关闭远端会话失败，仍进入评价页", error);
                }
            }
            // 不立刻 endSession：进入评价页，等 Submit Rating / Start new chat
            dispatch({
                type: ACTION_UPDATE_CONVERSATION_STATE,
                payload: { conversationState: "closed" }
            });
        } catch (error) {
            console.error("退出聊天失败:", error);
            toaster.push({
                message: "退出失败，请稍后重试",
                variant: "error",
                dismissAfter: 3000
            });
        } finally {
            setIsClosing(false);
        }
    };

    return (
        <>
            <Box as="header" {...containerStyles}>
                <Text as="h2" {...titleStyles}>
                    {customTitle || "Live Chat"}
                </Text>
                {showExit ? (
                    <Button variant="secondary" size="small" onClick={handleExit} disabled={isClosing}>
                        退出
                    </Button>
                ) : null}
            </Box>
            <ToastContainer>
                {toaster.toasts.map((toast, index) => (
                    <Toast key={index} {...toast}>
                        {toast.message}
                    </Toast>
                ))}
            </ToastContainer>
        </>
    );
};
